import React from 'react';
import './App.css';
import Questionnaire from './Questionnaire';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Questionnaire />
      </header>
    </div>
  );
}

export default App;
